<template>
	<canvas v-bind:id="skala" class="ampel" width="400" height="70">Ihr Browser unterst&uuml;tzt das Element <code>canvas</code> nicht.</canvas>
</template>
<script>
	import axios from 'axios';
	export default {
		name: 'Ampel',
		props: {
			skala: String,
			gruppe: String,
			benchmarkAnzeigen: Boolean,
			gruppeAnzeigen: Boolean	
		},
		data: function() {
			return {
				auswertung: {},
				ergebnis: {},
				xo: 10,
				yo: 20,
				rand: 20,
				stufen: 5
			}
		},
		mounted() {
			this.auswertungHolen(this.teilnehmer, this.skala, this.gruppe, this.gruppeAnzeigen);
		},
		computed: {
			teilnehmer() {
				return this.$store.state.teilnehmer;
			}
		},
		watch: {
			benchmarkAnzeigen: function() {
				this.auswertungHolen(this.teilnehmer, this.skala, this.gruppe, this.gruppeAnzeigen);
			},
			gruppeAnzeigen: function() {
				this.auswertungHolen(this.teilnehmer, this.skala, this.gruppe, this.gruppeAnzeigen);
			}
		},
		methods: {
			auswertungHolen(teilnehmer, skala, gruppe) {
				// this.teilnehmer = 'j874y0asdsadsad';
				axios.get('https://www.arbeitsverdichtung.de/api/auswertung', {
					params: {
						teilnehmer: teilnehmer,
						skala: skala, 
						gruppe: gruppe
					}
				})
				.then(response => {
					// console.log('Ergebnisse');
					// console.log(response.data);
					if ('teilnehmer' in response.data) {
						var person_m = Number.parseFloat(response.data['teilnehmer'][skala]['m']);
					}
					if ('benchmark' in response.data) {
						var norm_n = Number.parseFloat(response.data['benchmark'][skala]['n']);
						var norm_m = Number.parseFloat(response.data['benchmark'][skala]['m']);
						var norm_sd = Number.parseFloat(response.data['benchmark'][skala]['sd']); 
					}
					// Bei Gruppenauswertung kommt kein Punkt für die Person
					if ('gruppe' in response.data) {
						var gruppe_n = Number.parseFloat(response.data['gruppe'][skala]['n']);
						var gruppe_m = Number.parseFloat(response.data['gruppe'][skala]['m']);
						var gruppe_sd = Number.parseFloat(response.data['gruppe'][skala]['sd']); 
					}
					this.ampelLeeren({canvasId: skala});
					if (this.benchmarkAnzeigen == true) {
						this.ampelBenchmark({canvasId: skala, norm_n: norm_n, norm_m: norm_m, norm_sd: norm_sd});
					} else {
						this.ampelVerlauf({canvasId: skala});
					}
					this.ampelRahmen({canvasId: skala});
					this.ampelSkala({canvasId: skala});
					this.ampelDreieck({canvasId: skala});
					if ((this.gruppeAnzeigen == true) & ('gruppe' in response.data)) {
						this.ampelGruppe({canvasId: skala, gruppe_n: gruppe_n, gruppe_m: gruppe_m, gruppe_sd: gruppe_sd});
					}
					if (this.teilnehmer != '') {
						this.ampelTeilnehmer({canvasId: skala, person_m: person_m});
					}
				})
				.catch(error => {
					this.errorMessage = error.message;
					console.error("There was an error!", error);
				});
			},
			// Ampel leeren
			ampelLeeren: function(config) {
				// this.canvas = document.getElementById(config.canvasId);
				// this.context = this.canvas.getContext('2d');
				// if (this.canvas.width > window.innerWidth) this.canvas.width = window.innerWidth;	
				// this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);	
				var s = document.getElementById(config.canvasId);
				var w = s.width;
				s.width = 10;
				s.width = w;
			},
			// Zeichnen der Ampeln: Rahmen um die Ampel herum
			ampelRahmen: function(config) {
				this.canvas = document.getElementById(config.canvasId);
				this.context = this.canvas.getContext('2d');
				if (this.canvas.width > window.innerWidth) this.canvas.width = window.innerWidth;	
				var ampelhoehe = this.canvas.height-this.rand*2;
				var ampelbreite = this.canvas.width-this.rand*2;
				// var stufenbreite = ampelbreite/(this.stufen-1);
				// Rahmen um die Abbildung
				this.context.lineWidth = 1;
				this.context.strokeStyle = '#000000';
				this.context.rect(this.xo+0.5, this.yo+0.5, ampelbreite, ampelhoehe);
				this.context.stroke();
			},
			// Zeichnen der Ampeln: Dreieck über der Ampel
			ampelDreieck: function(config) {
				this.canvas = document.getElementById(config.canvasId);
				this.context = this.canvas.getContext('2d');
				if (this.canvas.width > window.innerWidth) this.canvas.width = window.innerWidth;	
				// var ampelhoehe = this.canvas.height-this.rand*2;
				var ampelbreite = this.canvas.width-this.rand*2;
				// var stufenbreite = ampelbreite/(this.stufen-1);
				// Rahmen um die Abbildung
				this.context.lineWidth = 1;
				this.context.strokeStyle = '#000000';
				this.context.fillStyle = '#000000';	
				this.context.beginPath();
				this.context.moveTo(this.xo,this.yo-5);
				this.context.lineTo(this.xo+ampelbreite,this.yo-5);
				this.context.lineTo(this.xo+ampelbreite,this.yo-15);
				this.context.fill();
			},
			// Zeichnen der Ampeln: Skala in die Ampel mit aufnehmen.
			ampelSkala: function(config) {
				this.canvas = document.getElementById(config.canvasId);
				this.context = this.canvas.getContext('2d');
				if (this.canvas.width > window.innerWidth) this.canvas.width = window.innerWidth;	
				var ampelhoehe = this.canvas.height-this.rand*2;
				var ampelbreite = this.canvas.width-this.rand*2;
				var stufenbreite = ampelbreite/(this.stufen-1);
				// Skala
				this.context.lineWidth = 1;
				this.context.strokeStyle = '#000000';
				this.context.font = '12px Arial';
				this.context.fillStyle = '#000000';			
				for (var i = 1; i <= this.stufen; i++) {
					var x = Math.round(this.xo+(i-1)*stufenbreite);
					this.context.translate(0.5, 0);
					this.context.moveTo(x, this.yo);
					this.context.lineTo(x, this.yo+ampelhoehe);
					this.context.stroke();
					this.context.translate(-0.5, 0);
					this.context.fillText(i, this.xo+(i-1)*stufenbreite-4, this.yo+ampelhoehe+12);
				}
			},
			// Benchmark mit Farben in die Ampel aufnehmen
			ampelVerlauf: function(config) {
				this.canvas = document.getElementById(config.canvasId);
				this.context = this.canvas.getContext('2d');
				if (this.canvas.width > window.innerWidth) this.canvas.width = window.innerWidth;	
				var ampelhoehe = this.canvas.height-this.rand*2;
				var ampelbreite = this.canvas.width-this.rand*2;
				this.context.globalAlpha=0.50;
				var gradient = this.context.createLinearGradient(this.xo, 0, ampelbreite, 0);
				gradient.addColorStop(0,'#fafafa');
				gradient.addColorStop(1,'#a0a0a0');
				this.context.fillStyle=gradient;
				this.context.fillRect(this.xo,this.yo,ampelbreite,ampelhoehe);
				this.context.globalAlpha=1.00;
			},
			// Benchmark mit Farben in die Ampel aufnehmen
			ampelBenchmark: function(config) {
				this.canvas = document.getElementById(config.canvasId);
				this.context = this.canvas.getContext('2d');
				if (this.canvas.width > window.innerWidth) this.canvas.width = window.innerWidth;	
				var ampelhoehe = this.canvas.height-this.rand*2;
				var ampelbreite = this.canvas.width-this.rand*2;
				var stufenbreite = ampelbreite/(this.stufen-1);
				this.context.globalAlpha=0.50;
				var gradient = this.context.createLinearGradient(this.xo, 0, ampelbreite, 0);
				// Ampel
				// var farben = ['#ea5f00','#ffd319','#ffff66','#ffff66','#ffff66','#9fee00','#70a800'];
				var farben = ['#70a800','#9fee00','#ffff66','#ffff66','#ffff66','#ffd319','#ea5f00'];
				// Mit der max/min-Funktion wird sichergestellt, dass die Schwelle nicht oberhalb des rechten/linken Randes der Ampel liegt
				var schwellen = [
					Math.min(Math.max(this.xo,this.xo),ampelbreite),
					Math.min(Math.max(this.xo,this.xo+(((config.norm_m-1)-(1.00*config.norm_sd))*stufenbreite)),ampelbreite),
					Math.min(Math.max(this.xo,this.xo+(((config.norm_m-1)-(0.50*config.norm_sd))*stufenbreite)),ampelbreite),
					Math.min(Math.max(this.xo,this.xo+(((config.norm_m-1)-(0.00*config.norm_sd))*stufenbreite)),ampelbreite),
					Math.min(Math.max(this.xo,this.xo+(((config.norm_m-1)+(0.50*config.norm_sd))*stufenbreite)),ampelbreite), 
					Math.min(Math.max(this.xo,this.xo+(((config.norm_m-1)+(1.00*config.norm_sd))*stufenbreite)),ampelbreite),
					Math.min(Math.max(this.xo,ampelbreite),ampelbreite)
				];
				// console.log(stufenbreite + ' / ' + config.norm_n + ' / ' + config.norm_m + ' / ' + config.norm_sd);
				// console.log(schwellen);
				if (config.norm_n < 10) {
					this.context.fillStyle=gradient;
					this.context.fillRect(this.xo,this.yo,ampelbreite,ampelhoehe);
					this.context.globalAlpha=1.00;	        
					this.context.font = '9px Arial';
					this.context.fillStyle = '#555555';	
					this.context.fillText('Fallzahl für den Benchmark zu gering (N = '+config.norm_n+')', this.xo+5, this.yo+ampelhoehe/2+5);	
				} else {
					gradient.addColorStop(schwellen[0]/ampelbreite,farben[0]);
					gradient.addColorStop(schwellen[1]/ampelbreite,farben[1]);
					gradient.addColorStop(schwellen[2]/ampelbreite,farben[2]);
					gradient.addColorStop(schwellen[3]/ampelbreite,farben[3]);
					gradient.addColorStop(schwellen[4]/ampelbreite,farben[4]);
					gradient.addColorStop(schwellen[5]/ampelbreite,farben[5]);
					gradient.addColorStop(1,farben[6]);
					this.context.fillStyle=gradient;
					this.context.fillRect(this.xo,this.yo,ampelbreite,ampelhoehe);
					this.context.globalAlpha=1.00;	
					this.context.font = '12px Arial';
					this.context.fillStyle = '#000000';	
					this.context.fillText('N = '+config.norm_n, this.xo+5, this.yo+ampelhoehe/2+5);	
					//this.context.fillText('N = '+config.norm_n+', M = '+(Math.round(config.norm_m*100)/100)+', SD = '+(Math.round(config.norm_sd*100)/100), this.xo+5, this.yo+ampelhoehe/2+5);	
				}
			},
			// Wert des jeweiligen Teilnehmers in die Ampel aufnehmen
			ampelTeilnehmer: function(config) {
				this.canvas = document.getElementById(config.canvasId);
				this.context = this.canvas.getContext('2d');
				if (this.canvas.width > window.innerWidth) this.canvas.width = window.innerWidth;	
				var ampelhoehe = this.canvas.height-this.rand*2;
				var ampelbreite = this.canvas.width-this.rand*2;
				var stufenbreite = ampelbreite/(this.stufen-1);
				// Mittelwert der jeweiligen Person
				this.context.beginPath();
				this.context.lineWidth = 0;
				this.context.strokeStyle = '#0000ff';
				this.context.fillStyle = '#0000ff';	
				this.context.arc(this.xo+(config.person_m-1)*stufenbreite, this.yo+ampelhoehe/2, 10, 0, 2*Math.PI);
				this.context.fill();
			},
			// Wert der jeweiligen Gruppe in die Ampel aufnehmen
			ampelGruppe: function(config) {
				this.canvas = document.getElementById(config.canvasId);
				this.context = this.canvas.getContext('2d');
				if (this.canvas.width > window.innerWidth) this.canvas.width = window.innerWidth;	
				var ampelhoehe = this.canvas.height-this.rand*2;
				var ampelbreite = this.canvas.width-this.rand*2;
				var stufenbreite = ampelbreite/(this.stufen-1);
				if (config.gruppe_n < 5) {
					this.context.font = '9px Arial';
					this.context.fillStyle = '#aaaaaa';	
					this.context.fillText('Fallzahl für die Gruppenauswertung zu gering (N = '+config.gruppe_n+')', this.xo+5, this.yo+ampelhoehe/2+5);        
				} else {
					var radius = 10;
					this.context.lineWidth = 1;
					this.context.strokeStyle = '#0000ff';
					this.context.fillStyle = '#0000ff';	
					// Mittelwert der Gruppe
					this.context.beginPath();
					this.context.arc(this.xo+(config.gruppe_m-1)*stufenbreite, this.yo+ampelhoehe/2, radius, 0, 2*Math.PI);
					this.context.stroke();
					// Standardabweichung der Gruppe
					this.context.beginPath();
					this.context.moveTo(this.xo+(config.gruppe_m-1)*stufenbreite-(config.gruppe_sd)*stufenbreite, this.yo+ampelhoehe/2-ampelhoehe/4);
					this.context.lineTo(this.xo+(config.gruppe_m-1)*stufenbreite-(config.gruppe_sd)*stufenbreite, this.yo+ampelhoehe/2+ampelhoehe/4);
					this.context.moveTo(this.xo+(config.gruppe_m-1)*stufenbreite+(config.gruppe_sd)*stufenbreite, this.yo+ampelhoehe/2-ampelhoehe/4);
					this.context.lineTo(this.xo+(config.gruppe_m-1)*stufenbreite+(config.gruppe_sd)*stufenbreite, this.yo+ampelhoehe/2+ampelhoehe/4);
					this.context.moveTo(this.xo+(config.gruppe_m-1)*stufenbreite-(config.gruppe_sd)*stufenbreite, this.yo+ampelhoehe/2);
					this.context.lineTo(this.xo+(config.gruppe_m-1)*stufenbreite-radius, this.yo+ampelhoehe/2);
					this.context.moveTo(this.xo+(config.gruppe_m-1)*stufenbreite+radius, this.yo+ampelhoehe/2);
					this.context.lineTo(this.xo+(config.gruppe_m-1)*stufenbreite+(config.gruppe_sd)*stufenbreite, this.yo+ampelhoehe/2);
					this.context.closePath();
					this.context.stroke();
				}
			}
		}
	}
</script>
<style scoped>
</style>
